import {createContext} from "react";
import SimpleQRCode from "../../../../api/qr-code/SimpleQRCode";

type QRCodeStyleDialogContextType = {
    /**
     * Open the dialog
     * @since 0.1.9
     * @author Kacper Faber
     */
    open: (qrCode: SimpleQRCode) => void;

    /**
     * Close the dialog
     * @since 0.1.9
     * @author Kacper Faber
     */
    close: () => void;

    /**
     * Is dialog opened
     * @since 0.1.9
     * @author Kacper Faber
     */
    isOpened: boolean

    /**
     * QRCode to edit styles in.
     * Should be undefined when dialog is not visible.
     * @author Kacper Faber
     * @since 0.1.9
    */
    qrCode: SimpleQRCode | undefined;
}

/**
 * Throws not implemented.
 * To use by default in the methods.
 * @since 0.1.9
 * @author Kacper Faber
 */
const notImpl = () => {
    throw new Error('Not implemented!');
}

/**
 * Default values
 * @since 0.1.9
 * @author Kacper Faber
 */
const defaults: QRCodeStyleDialogContextType = {
    open: notImpl,
    close: notImpl,
    isOpened: false,
    qrCode: undefined
};

/**
 * Context to work with QRCodeStyleDialog.
 * @since 0.1.9
 * @author Kacper Faber
 */
const ctx = createContext<QRCodeStyleDialogContextType>(defaults);

export default ctx;